.loader {
  line-height: 0;
  pointer-events: none;
  border-radius: 100%;
}
.loader.padding-window {
  padding: var(--ui-padding-uiWindow);
}
.loader.hidden {
  display: none;
}
.loader > div {
  border-radius: 100%;
  width: 20px;
  height: 20px;
  -webkit-animation: spin-loading 12s ease-out;
  -webkit-animation-iteration-count: infinite;
  -moz-animation: spin-loading 12s ease-out;
  -moz-animation-iteration-count: infinite;
  animation: spin-loading 12s ease-out;
  animation-iteration-count: infinite;
}
.loader > div svg {
  max-width: 100%;
  height: auto;
}
.loader.center {
  position: absolute;
  top: calc(50% - 10px);
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader.flex-center {
  display: inline-flex;
  align-self: center;
  justify-self: center;
}
.loader.dark svg > * {
  opacity: 0.6;
  color: var(--ui-color-flat-reverse);
  fill: var(--ui-color-flat-reverse);
}
.loader.light svg > * {
  opacity: 0.25;
  color: var(--ui-color-flat-reverse);
  fill: var(--ui-color-flat-reverse);
}
.loader.linear > div {
  fill: var(--ui-color-flat);
  transform-origin: center;
  -webkit-animation: linear-spin 1s linear;
  -webkit-animation-iteration-count: infinite;
  -moz-animation: linear-spin 1s linear;
  -moz-animation-iteration-count: infinite;
  animation: linear-spin 1s linear;
  animation-iteration-count: infinite;
}
.loader.fade-in {
  opacity: 0;
  animation-delay: 0.1s;
  -webkit-animation-delay: 0.1s;
  -moz-animation-delay: 0.1s;
  animation-duration: 12s;
  animation-iteration-count: infinite;
  animation: fade-in 0.8s ease-in-out;
  -moz-animation: fade-in 0.8s ease-in-out;
  -webkit-animation: fade-in 0.8s ease-in-out;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.loader.linear > div {
  transform-origin: center;
  -webkit-animation: linear-spin var(--ui-load-spinner-large-speed) linear infinite;
  -moz-animation: linear-spin var(--ui-load-spinner-large-speed) linear infinite;
  animation: linear-spin var(--ui-load-spinner-large-speed) linear infinite;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.loader.linear > div.delay {
  animation-delay: 0.8;
  -webkit-animation-delay: 0.5;
  -moz-animation-delay: 0.5;
}
.loader.reverse > div {
  animation-direction: reverse;
}
.loader *.red > div {
  fill: red !important;
}

@-webkit-keyframes spin-loading {
  0% {
    transform: rotate(0deg);
  }
  9% {
    transform: rotate(1050deg);
  }
  18% {
    transform: rotate(-1090deg);
  }
  20% {
    transform: rotate(-1080deg);
  }
  23% {
    transform: rotate(-1080deg);
  }
  28% {
    transform: rotate(-1095deg);
  }
  29% {
    transform: rotate(-1065deg);
  }
  34% {
    transform: rotate(-1080deg);
  }
  35% {
    transform: rotate(-1050deg);
  }
  40% {
    transform: rotate(-1065deg);
  }
  41% {
    transform: rotate(-1035deg);
  }
  44% {
    transform: rotate(-1035deg);
  }
  47% {
    transform: rotate(-2160deg);
  }
  50% {
    transform: rotate(-2160deg);
  }
  56% {
    transform: rotate(45deg);
  }
  60% {
    transform: rotate(45deg);
  }
  80% {
    transform: rotate(6120deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
/*spinning */
@-webkit-keyframes spin-loading {
  0% {
    transform: rotate(0deg);
  }
  9% {
    transform: rotate(1050deg);
  }
  18% {
    transform: rotate(-1090deg);
  }
  20% {
    transform: rotate(-1080deg);
  }
  23% {
    transform: rotate(-1080deg);
  }
  28% {
    transform: rotate(-1095deg);
  }
  29% {
    transform: rotate(-1065deg);
  }
  34% {
    transform: rotate(-1080deg);
  }
  35% {
    transform: rotate(-1050deg);
  }
  40% {
    transform: rotate(-1065deg);
  }
  41% {
    transform: rotate(-1035deg);
  }
  44% {
    transform: rotate(-1035deg);
  }
  47% {
    transform: rotate(-2160deg);
  }
  50% {
    transform: rotate(-2160deg);
  }
  56% {
    transform: rotate(45deg);
  }
  60% {
    transform: rotate(45deg);
  }
  80% {
    transform: rotate(6120deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
/* linear spin */
@keyframes linear-spin {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(36deg);
  }
  20% {
    transform: rotate(72deg);
  }
  30% {
    transform: rotate(108deg);
  }
  40% {
    transform: rotate(144deg);
  }
  50% {
    transform: rotate(180deg);
  }
  60% {
    transform: rotate(216deg);
  }
  70% {
    transform: rotate(252deg);
  }
  80% {
    transform: rotate(288deg);
  }
  90% {
    transform: rotate(324deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes delay {
  0% {
    opacity: 0;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */